import type { AxiosInstance } from 'axios';

import type { CastorMaterialList } from '@accio3d/shared/domain';

/**
 * Builds the client for Castor's static material list.
 * @param client the authenticated API client
 * @returns the service reading GET /castor-materials
 */
export function createCastorMaterialsService(client: AxiosInstance) {
  return {
    list: async (): Promise<CastorMaterialList> => {
      const { data } = await client.get<CastorMaterialList>('/castor-materials');
      return data;
    },
  };
}

export type CastorMaterialsService = ReturnType<typeof createCastorMaterialsService>;
